import type { EmblemRarity } from "@/lib/domain/EmblemRarity";
import type { EmblemSetType } from "@/lib/domain/EmblemSet";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface EmblemResponseModel {
	readonly emblemId: string;
	readonly name: string;
	readonly description: string;
	readonly rarity: EmblemRarity;
	readonly set: EmblemSetType;
	readonly count: number;
}

export const useEmblem = () => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["emblem"],
		queryFn: () => {
			return http<EmblemResponseModel>({
				method: "GET",
				url: "/emblem/active"
			});
		}
	});
};
